import type { CustomVariablesDataPayload, SegmentsOptions } from '@openx/types/targeting/customVariables';
import { useTargetingContext } from '../../../utils/context/TargetingContext';
import { useContextualAccount } from './useContextualAccount';
import { useContextualSegmentMetadata } from './useContextualSegmentMetadata';

export type UseGetContextualSummaryData = (
  accountUid: string,
  params: CustomVariablesDataPayload[]
) => {
  loading: boolean;
  providerIds: string[];
  segments: SegmentsOptions;
  hasAvailableSegments: boolean;
  cacheSegmentMetadata: (segments: SegmentsOptions) => void;
};

export const useGetContextualSummaryData: UseGetContextualSummaryData = (accountUid, params) => {
  const { useFetchSegments } = useTargetingContext();
  const { accountId, loading: organizationsLoading, providerIds } = useContextualAccount(accountUid);
  const hasProvider = providerIds.length > 0;
  const {
    loading: selectedSegmentsLoading,
    segments,
    cacheSegmentMetadata,
  } = useContextualSegmentMetadata(accountId, providerIds, params);

  // Cheap catalog probe — only when the account has a contextual provider.
  const { segments: availableSegments, loading: availabilityLoading } = useFetchSegments({
    account_id: hasProvider ? accountId : undefined,
    limit: 1,
    offset: 0,
  });

  return {
    loading: organizationsLoading || (hasProvider && availabilityLoading) || selectedSegmentsLoading,
    providerIds,
    segments,
    hasAvailableSegments: availableSegments.length > 0,
    cacheSegmentMetadata,
  };
};
